// UsersApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to authentication
export const addTagTypes = ['auth', 'user'];

// Enhance the base API service by adding authentication-related tag types
const UsersApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Login mutation (POST request to /signin)
      login: build.mutation({
        query: (credentials) => ({
          url: `/auth/signin`,
          method: 'POST',
          data: credentials,
        }),
        invalidatesTags: ['auth'],
      }),
 
      // Signup mutation (POST request to /auth/signup)
      signup: build.mutation({
        query: (credentials) => ({
          url: '/auth/signup',
          method: 'POST',
          data: credentials,
        }),
        invalidatesTags: ['user'], // Invalidate user tags to refresh the user list
      }),

      // Fetch user profile query (GET request to /me)
      getUserProfile: build.query({
        query: () => ({
          url: `/auth/users`,
        }),
        providesTags: ['user'],
      }),

      // Logout mutation (POST request to /signout)
      logout: build.mutation({
        query: () => ({
          url: `/auth/signout`,
          method: 'POST',
        }),
        invalidatesTags: ['auth', 'user'],
      }),

      // Token refresh mutation (POST request to /refreshtoken)
      refreshToken: build.mutation({
        query: (tokenData) => ({
          url: `/auth/refreshtoken`,
          method: 'POST',
          data: tokenData,
        }),
        invalidatesTags: ['auth'],
      }),

      // Delete user mutation (DELETE request to /auth/deleteuser/{id})
      deleteUser: build.mutation({
        query: (id) => ({
          url: `/auth/deleteuser/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['user'], // Invalidate the user tag after deletion
      }),

      // Update user mutation (PUT request to /auth/updateuser/{id})
      updateUser: build.mutation({
        query: ({ id, username, email, nomPrenom, phoneNumber, password, role }) => ({
          url: `/auth/updateuser/${id}`,
          method: 'PUT',
          data: { username, email, nomPrenom, phoneNumber, password, role },
        }),
        invalidatesTags: ['user'], // Invalidate user tags to refresh the user list
      }),
 // RestPassword user mutation (PUT request to /auth/updateuser/{id})
 resetpasswordUser: build.mutation({
  query: ({ id,password }) => ({
    url: `/auth/updatePassword/${id}`,
    method: 'PUT',
    data: {password},
  }),
  invalidatesTags: ['user'], // Invalidate user tags to refresh the user list
}),
updateUserProfile: build.mutation({
  query: ({ id,ProfileRequestUpdate }) => ({
    url: `/auth/updateuserProfile/${id}`,
    method: 'PUT',
    data: ProfileRequestUpdate,
  }),
  invalidatesTags: ['user'], // Invalidate user tags to refresh the user list
}),   

 
userProfleById: build.query({
  query: (id) => ({
    url: `/auth/usersbyId/${id}`,
  }),
  providesTags: ['user'],
}),
    }),
    overrideExisting: false,
  });

export default UsersApi;

// Exporting hooks for each endpoint to be used in components
export const {
   
  useUserProfleByIdQuery,
  useUpdateUserProfileMutation,
  useResetpasswordUserMutation,
  useLoginMutation,
  useSignupMutation,
  useGetUserProfileQuery,
  useLogoutMutation,
  useDeleteUserMutation,
  useUpdateUserMutation,
  useRefreshTokenMutation,
} = UsersApi;

// Type definitions for the API responses and requests
 
export const defaultUser = {
  id: '',
  username: '',
  email: '',
  nomPrenom: '',
  phoneNumber: '',
  password: '',
  roles: [],
};
 
export const ProfileRequestUpdate = {
  username: "",       // String value for the username (minLength: 3, maxLength: 20)
  nomPrenom: "",      // Optional: String value for full name (maxLength: 50)
  phoneNumber: "",    // String value for the phone number (maxLength: 50)
  email: "",          // String value for email address (maxLength: 50)
  firstName: "",      // Optional: String value for first name (maxLength: 50)
  lastName: "",       // Optional: String value for last name (maxLength: 50)
  shopName: ""        // Optional: String value for shop name (maxLength: 50)
};
export const defaultProfileValues = {
  username: "",       // String value for the username (minLength: 3, maxLength: 20)
  nomPrenom: "",      // Optional: String value for full name (maxLength: 50)
  phoneNumber: "",    // String value for the phone number (maxLength: 50)
  email: "",          // String value for email address (maxLength: 50)
  firstName: "",      // Optional: String value for first name (maxLength: 50)
  lastName: "",       // Optional: String value for last name (maxLength: 50)
  shopName: ""        // Optional: String value for shop name (maxLength: 50)
};

